(function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('ColorPicker', ['AColorPicker'], factory);
    } else {
        // Browser globals
        root.ColorPicker = factory(root.AColorPicker);
    }
}(typeof self !== 'undefined' ? self : this, function ($acp) {
        'use strict';

        function ColorPicker(element) {
            this.container = element;
            if (!this.container) return;
            this.input = this.container.querySelector('input[type="text"]');
            this.picker = this.container.querySelector('.picker');
            this.preview = this.container.querySelector('.preview');

            if (!this.input || !this.picker || !this.preview) return;

            this.onpick = this.onpick.bind(this);
            this.onblur = this.onblur.bind(this);
            this.onfocus = this.onfocus.bind(this);
            this.oninput = this.oninput.bind(this);
            this.onenter = this.onenter.bind(this);
            this.onleave = this.onleave.bind(this);

            this.color = this.input.value ? this.input.value : this.color;
            this.input.value = this.color;
            this.preview.style.backgroundColor = this.color;

            this.$picker = $acp.createPicker({
                attachTo: this.picker,
                showHSL: false,
                showRGB: false,
                showHEX: false,
                color: this.color
            });

            this.$picker.onchange = this.onpick;
            this.input.addEventListener('input', this.oninput);
            this.input.addEventListener('focus', this.onfocus);
            this.input.addEventListener('blur', this.onblur);
            this.picker.addEventListener('mouseenter', this.onenter);
            this.picker.addEventListener('mouseleave', this.onleave);
            this.preview.addEventListener('click', this.onfocus);
        }

        ColorPicker.prototype = {
            color: '#ffffff',
            onpick: function ($picker) {
                this.color = $picker.color;
                this.input.value = this.color;
                this.preview.style.backgroundColor = this.color;
            },
            onenter: function (event) {
                this.active = true;
            },
            onleave: function (event) {
                this.active = false;
                this.input.blur();
                this.onblur(this.input);
            },
            onfocus: function (event) {
                this.picker.classList.remove('-hidden');
            },
            onblur: function (event) {
                if (this.active) return;
                this.picker.classList.add('-hidden');
            },
            oninput: function(event) {
                if (this.$picker.color == this.input.value) return;
                if (this.input.value.length < 7) return;
                if (this.input.value[0] !== '#') return;
                this.color = this.input.value;
                this.$picker.color = this.color;
                this.preview.style.backgroundColor = this.color;
            }
        }

        return ColorPicker;
}));